import { z } from 'zod';
import { OrgId, UserId } from '../types/branded';
import { ActivityActionSchema } from '../types/enums';

export const ActivityLogSchema = z.object({
  id: z.string().min(1),
  orgId: OrgId,
  entityType: z.string().min(1),
  entityId: z.string().min(1),
  action: ActivityActionSchema,
  actorId: UserId,
  actorRole: z.string().nullable().optional(),
  details: z.record(z.string(), z.unknown()).nullable().optional(),
  occurredAt: z.string(),
});
export type ActivityLog = z.infer<typeof ActivityLogSchema>;
